import React, { useState, useEffect } from 'react';
import THEME from '../utils/theme';
import { FaArrowUp } from 'react-icons/fa';

export default function ScrollTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const h = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  if (!show) return null;

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      title="Back to top"
      style={{
        position: 'fixed', bottom: 32, right: 32,
        width: 48, height: 48, borderRadius: '50%',
        background: THEME.red, color: 'white',
        border: 'none', cursor: 'pointer',
        boxShadow: `0 8px 24px ${THEME.red}60`, zIndex: 999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'transform 0.2s, box-shadow 0.2s',
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.12)'; e.currentTarget.style.boxShadow = `0 12px 32px ${THEME.red}80`; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = `0 8px 24px ${THEME.red}60`; }}>
      <FaArrowUp size={18} />
    </button>
  );
}
